module.exports = __webpack_public_path__ + "static/img/environment.69e1c098.png";